import { z } from "zod";
import i18next from "i18next";
import { FIELD_REQUIRED } from "../../../../../i18n/keysTranslations";
import { ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION } from "../../../../../utils/constants";

export const tiktokBaseSchema = z.object({
  objective: z.string().min(1, i18next.t(FIELD_REQUIRED)),
  integrationID: z.string().min(1, i18next.t(FIELD_REQUIRED)),
  adAccountID: z.string().min(1, i18next.t(FIELD_REQUIRED)),
  identityTikTokID: z.string().min(1, i18next.t(FIELD_REQUIRED)),

  useCampaignBudget: z.any().optional(),
  typeBudget: z.any().optional(),
  budget: z.any().optional(),

  isIOS14Campaign: z.any().optional(),
  appID: z.any().optional(),
  type: z.any().optional(),
});

export const tiktokCampaignSchema = tiktokBaseSchema.superRefine(
  (data, ctx) => {
    if (data.useCampaignBudget) {
      if (!data.typeBudget) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["typeBudget"],
          message: i18next.t(FIELD_REQUIRED),
        });
      }
      if (!data.budget) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["budget"],
          message: i18next.t(FIELD_REQUIRED),
        });
      }
    }

    if (
      data.objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION &&
      data.isIOS14Campaign &&
      !data.appID
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["appID"],
        message: i18next.t(FIELD_REQUIRED),
      });
    }
  }
);
